import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=853f4526&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=853f4526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853f4526",
  null
  
)

export default component.exports